import ClearIcon from 'app/ui_v2/icons/ClearIcon';

import { Box, Chip, SxProps, Theme, Tooltip, useTheme } from '@mui/material';

export interface ChipsListItem {
  name: string | JSX.Element;
  id: string;
  classNames?: string;
  tooltip?: string | JSX.Element;
}

export interface ChipListProps {
  list: ChipsListItem[];
  classNames?: string;
  onDelete?: (id: string) => void;
  onClick?: (id: string) => void;
  isClickable?: boolean;
}

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      listStyle: 'none',
      padding: 0,
      '& > li': {
        maxWidth: `calc(100% - ${theme.spacing(2)}px)`,
      },
    },
  };
};

export default function ChipList(props: ChipListProps) {
  const { list, classNames, onDelete, isClickable = false, onClick = () => {} } = props;

  const theme = useTheme();
  const styles = getStyles(theme);
  return (
    <Box mx={-1} component="ul" display="flex" flexWrap="wrap" sx={styles.root}>
      {list.map((item: ChipsListItem, index: number) => (
        <Box component="li" mx={1} my={1} key={index}>
          <Tooltip title={item.tooltip} placement="bottom" arrow>
            <Chip
              clickable={isClickable}
              className={item.classNames || classNames}
              label={item.name}
              onDelete={
                onDelete &&
                (() => {
                  onDelete(item.id);
                })
              }
              deleteIcon={
                <Box fontSize="1.3rem" display="flex" alignItems="center">
                  <ClearIcon fontSize="inherit" />
                </Box>
              }
              onClick={
                isClickable && onClick
                  ? () => {
                      onClick(item.id);
                    }
                  : undefined
              }
            />
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
}
